import { render, staticRenderFns } from "./Ampifire.vue?vue&type=template&id=48a9d258&"
import script from "./Ampifire.vue?vue&type=script&lang=ts&"
export * from "./Ampifire.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports